
import 'es6-promise/auto'
import Postmate from '@regily/regily-postmate'

import partnerEnv from './config/partner'
import loaderSettings from './config/loader'
import flowSettings from './config/settings'
import flowVariants from './config/variants'

import storage from '../utils/storage.js'
import moduleStyling from '../assets/preload-style.scss.dynamic'
import superagent from 'superagent'
import socialMedia from '../utils/socialMedia'
import transformData from '../utils/data-transfrom'
import { isFromRemote, getDynamicSettings, getQueryParams, updateQueryString, delegateEvent } from '../utils/browserStructure'
import Recaptcha from '../utils/recaptcha'
import '../../static/remote/intro.mp4'
import remoteStatus from './remote-status'
import modal from '../utils/modal'
import validateStandaloneData from '../utils/standaloneDataValidation'
import { validateLoginData } from './verify/data'

const partnerConfig = {
  ...partnerEnv,
  loader: loaderSettings,
  settings: flowSettings,
  variants: flowVariants
}

let partnerViewport = null

const sleep = (time) => new Promise(resolve => setTimeout(resolve, time))
const getEnv = () => {
  const gitBranch = process.env.GIT_BRANCH.split('/')
  const envIndex = gitBranch && gitBranch[0] === 'release' ? 1 : 0
  return gitBranch[envIndex]
}

const getPartnerServeUrl = (releaseData) => {
  let partnerServerUrl
  const env = getEnv()

  if (partnerConfig.settings.useDynamicCopyFromOwnSubDomain) {
    partnerServerUrl = '/translations'
  } else {
    partnerServerUrl = `https://${env === 'staging' ? 'staging-' : ''}partnerserve.regily.com/translations`
  }

  // Load partner and variant variable to translation api url
  partnerServerUrl = `${partnerServerUrl}/${partnerConfig.settings.partnerId}/${(releaseData && releaseData.id) || 'default'}/${getDynamicSettings().regilyVariant || 'core'}`
  return partnerServerUrl
}

if (partnerConfig.loader.enableNonHashControls && !isFromRemote()) {
  Object.defineProperty(window, 'regily', {
    configurable: false,
    value: {
      signUp: {
        isOpen: false,
        open: function () {
          this.isOpen = true
          partner.openFrameIfNeeded()
        },
        close: function () {
          this.isOpen = false
          partner.closeFrameIfNeeded()
        }
      },
      addEventAliases () {
        window.addEventListener('regilySignUpOpen', this.signUp.open, false)
        window.addEventListener('regilySignUpClose', this.signUp.close, false)
      }
    }
  })

  window.regily.signUp.open = window.regily.signUp.open.bind(window.regily.signUp)
  window.regily.signUp.close = window.regily.signUp.close.bind(window.regily.signUp)
}

const partner = {
  hashes: ['#signup', '#regily', '#playnow', '#registrate'],
  delegate: null,
  postmate: null,
  loadingPostmate: false,
  holder: null,
  moduleOverlay: null,
  isModuleOverlaySet: false,
  originalStyle: null,
  config: {},
  scrollY: 0,
  iframeUrl: null,
  isPlayground: !!document.querySelector('script[src*="/playground.js"]'),
  isPartnerRegilyPage: window.location.hostname.indexOf(`${partnerConfig.hostnameId}.regily.com`) !== -1,
  recaptcha: null,
  documentHeight: document.documentElement.clientHeight,
  isFromRemote: isFromRemote(),
  dynamicSettings: getDynamicSettings,
  crossModuleDataTransfer: {},
  queryParams: getQueryParams(window.location),
  sofortDefaultRedirectUrl: `${window.location.origin}${window.location.pathname}`,

  start (settings) {
    if (settings) {
      this.dynamicSettings = () => settings
    }

    if (document.readyState !== 'loading') {
      this.init()
    } else {
      document.addEventListener('DOMContentLoaded', () => partner.init())
    }
  },

  init () {
    this.destroy()
    this.preparePage()

    this.release.getReleaseInfo().then(() => {
      this.triggerOpenIfNeeded()
    }).catch((error) => {
      console.warn('Could not get release test info, will use default:', error)
    })

    window.addEventListener('hashchange', this.openFrameIfNeeded, false)
    window.addEventListener('hashchange', this.closeFrameIfNeeded, false)
  },

  destroy () {
    if (this.postmate) {
      this.postmateDestroy()
    }

    if (this.holder) {
      this.holder.parentNode.removeChild(this.holder)
      this.holder = null
      this.frame = null
    }

    window.removeEventListener('hashchange', this.openFrameIfNeeded)
    window.removeEventListener('hashchange', this.closeFrameIfNeeded)

    if (this.delegate) {
      this.delegate.remove()
    }

    this.delegates = []
    this.originalStyle = null
    this.loadingPostmate = false
  },

  postmateDestroy () {
    this.postmate.destroy()
    this.postmateHandshake = null
  },

  prepareFrame () {
    if (!this.iframeUrl) {
      this.iframeUrl = this.getIframeUrl()
    }

    if (!this.holder) {
      const device = this.getDeviceInfo()

      this.holder = document.createElement('div')
      this.holder.classList.add('regily-module')
      document.body.appendChild(this.holder)

      let loader = document.createElement('div')
      loader.classList.add('loader')
      this.holder.appendChild(loader)

      if (partnerConfig.settings.showRegilyBadge && device === 'desktop') {
        const regilyBadge = document.createElement('a')
        regilyBadge.classList.add('badge')
        regilyBadge.textContent = 'Made easy with'
        regilyBadge.href = 'https://regily.com'
        regilyBadge.target = '_blank'
        regilyBadge.rel = 'noopener'
        this.holder.appendChild(regilyBadge)

        const host = this.getHost()
        const badgeLogo = document.createElement('img')
        badgeLogo.classList.add('logo')
        badgeLogo.src = `${host}/regily_logo_white.png`
        regilyBadge.appendChild(badgeLogo)
      }
    }

    if (this.postmateHandshake || this.loadingPostmate) {
      // Postmate already starting or started
      return
    }

    // Set loadingPostmate since the handshake takes thread-lock time..
    this.loadingPostmate = true

    // Postmate.debug = true
    this.postmateHandshake = new Postmate({
      container: this.holder,
      url: this.iframeUrl,
    // Set feature policy settings for iframe to ask for camera permission, this feature is needed for OCR providers
      beforeInjectFrame: (frame) => {
        frame.allow = "camera *"
      },
    }).then(this.prepareFrameCallback)
      .catch((err) => {
        this.loadingPostmate = false
        console.warn('Could not start postmate:', err)
        throw err
      })
    this.loadingPostmate = false
  },

  prepareModuleOverlay () {
    let regilyOverlay = this.holder.querySelector('.module-overlay')

    if (!regilyOverlay) {
      regilyOverlay = document.createElement('div')
      regilyOverlay.classList.add('module-overlay')
      this.holder.appendChild(regilyOverlay)
    }

    this.moduleOverlay = regilyOverlay

    // setTimeout compansates transition time of the corresponding in-module element. positionModuleOverlay requests measurements from the module, from an element which is holding screens (and is the area we are intrested in for the overlay to cover). Screen holder enters with a transition ("on appear"; https://github.com/Regily/ui/blob/staging/base-regily/src/components/App.vue#L2) and measurements are being caught mid transition.
    setTimeout(this.positionModuleOverlay, 1000)
    window.addEventListener('resize', this.positionModuleOverlay)

    this.postmate.on('toggleModuleOverlay', () => {
      const isHidden = this.moduleOverlay.classList.contains('hidden')

      if (isHidden) {
        this.moduleOverlay.classList.remove('hidden')
      } else {
        this.moduleOverlay.classList.add('hidden')
      }
    })
  },

  async positionModuleOverlay () {
    /**
   * a delay to wait the first call for the opening animation to finish before getting the dimensions, but not on resizing
   */
    if (!this.isModuleOverlaySet || !this.postmate) await sleep(500)

    this.postmate.get('moduleScreenMeasures').then((data) => {
      this.moduleOverlay.style.height = `${data.size.height}px`
      this.moduleOverlay.style.width = `${data.size.width}px`
      this.moduleOverlay.style.top = `${data.position.top}px`
      this.moduleOverlay.style.left = `${data.position.left}px`

      this.isModuleOverlaySet = true
    })
      .catch(() => console.log('Module screen measures failed.'))
  },

  prepareFrameCallback (postmate) {
    this.postmate = postmate || this.postmate
    this.frame = postmate.frame
    this.frame.frameborder = '0'
    this.frame.scrolling = 'no'
    this.frame.allow = 'camera *;microphone *;'

    this.prepareModuleOverlay()

    this.postmate.on('initLib', (lib) => {
      if (lib === 'recaptcha') {
        this.recaptcha = new Recaptcha({
          postmate: this.postmate,
          holder: this.moduleOverlay,
          wrapperClass: 'recaptcha-wrapper'
        })

        this.recaptcha.init()
      }
    })

    this.postmate.on('measure', () => {
      const device = this.getDeviceInfo()
      if (device === 'ios') {
        const height = document.documentElement.scrollTop > 0
          ? Math.min(document.documentElement.scrollTop, 280)
          : 280 // 280 as the max

        this.postmate.call('keyboard', height)
        document.body.scrollTop = 0
        window.scrollTo(0, 0)
        return
      }

      document.body.scrollTop = 0
      window.scrollTo(0, 0)
      window.scrollBy(0, 4000)

      const pingScroll = setInterval(() => {
        const scrollY = window.scrollY

        if (scrollY !== 4000) {
          clearInterval(pingScroll)

          const screenHeight = window.orientation === 0 ? window.screen.height : window.screen.width

          if (window.orientation === 0) {
            this.postmate.call('keyboard', scrollY)
          } else {
            this.postmate.call('keyboard', scrollY - (screenHeight - window.innerHeight))
          }

          document.body.scrollTop = this.scrollY
          window.scrollTo(0, 0)
        }
      }, 40)
    })

    this.postmate.on('scrollToTop', () => {
      document.body.scrollTop = 0
      window.scrollTo(0, 0)
    })

    this.postmate.on('initSocialMedia', async (data) => {
      const facebookAppId = data.facebookAppId
      const googleId = data.googleId
      const linkedInId = data.linkedInId

      if (facebookAppId) {
        socialMedia.initFacebook(this.postmate, facebookAppId)
      }

      if (googleId) {
        socialMedia.initGoogle(this.postmate, googleId)
      }

      if (linkedInId) {
        socialMedia.initLinkedIn(this.postmate, linkedInId)
      }
    })

    this.postmate.on('connectWithSocialMedia', async (data) => {
      switch (data.provider) {
        case 'facebook':
          socialMedia.initFacebook(this.postmate, data.facebookAppId).then(() => {
            socialMedia.connectFacebook(this.postmate)
          })
          break
        case 'google':
          socialMedia.connectGoogle(this.postmate)
          break
        case 'linkedin':
          socialMedia.connectLinkedIn(this.postmate)
      }
    })

    this.postmate.on('close', (flowComplete) => {
      this.closeModule()
      if (this.isFromRemote) {
        remoteStatus.closeFrame()
      }
    })

    this.postmate.on('update', ({ data, dataDiff }) => {
      const updateCallback = this.config.callbacks && this.config.callbacks.update
      const protectedData = data.protected || {}

      // delete protected data
      data.protected && delete data.protected

      if (updateCallback) {
        const promise = updateCallback(data, dataDiff)

        if (promise && promise.then) {
          promise.then(() => {
            this.postmate.call('dataCheckingStatus', { checking: false })
          }, (error) => {
            const errorName = error.name
            const errorData = {
              diff: dataDiff,
              name: errorName,
              title: error.title,
              message: error.message,
              action: error.action,
              path: protectedData.route && protectedData.route.currentPath
            }

            this.postmate.call('error', errorData)
          })
        }
      }
    })

    this.postmate.on('identification', (data) => {
      const identCallback = this.config.callback || (this.config.callbacks && this.config.callbacks.identification)

      if (identCallback) {
        const promise = identCallback(data)

        if (promise && promise.then) {
          promise.then((data) => {
            const userId = data && data.playerAccountId

            if (userId) {
              this.postmate.call('setKnownData', {
                storeKey: 'user',
                data: {
                  playerAccountId: userId
                }
              })
            }
          }, (error) => {
            const errorName = error.name
            const errorData = {
              name: errorName,
              title: error.title,
              message: error.message
            }

            this.postmate.call('error', errorData)
          })
        }
      }
    })

    this.postmate.on('loginCredentials', (data) => {
      const authenticationCallback = this.config.callback || (this.config.callbacks && this.config.callbacks.authentication)
      if (authenticationCallback) {
        const promise = authenticationCallback(data)

        if (promise && promise.then) {
          promise.then((data = {}) => {
            const authStatus = data.auth

            if (authStatus === 'LOGIN_FAILED') {
              const error = data.error || {}
              const errorName = error.name || 'loginFailed'
              const errorData = {
                name: errorName,
                title: error.title,
                message: error.message,
                skipError: true
              }

              return this.postmate.call('error', errorData)
            }

            this.postmate.call('dataCheckingStatus', { checkingLogin: false })
          }, (error) => {
            const errorName = error.name
            const errorData = {
              name: errorName,
              title: error.title,
              message: error.message
            }

            this.postmate.call('error', errorData)
          })
        }
      }
    })

    this.postmate.on('passwordReset', (data) => {
      const authenticationCallback = this.config.callback || (this.config.callbacks && this.config.callbacks.authentication)
      if (authenticationCallback) {
        const promise = authenticationCallback(data)

        if (promise && promise.then) {
          promise.then((data = {}) => {
            let authStatus = data.auth
            if (authStatus === 'CODE_FAILED') {
              const error = data.error || {}
              const errorName = error.name || 'emailResetFailed'
              const errorData = {
                name: errorName,
                title: error.title,
                message: error.message
              }
              return this.postmate.call('error', errorData)
            }

            this.postmate.call('dataCheckingStatus', { checkingSendEmail: false })
          }, (error) => {
            const errorName = error.name
            const errorData = {
              name: errorName,
              title: error.title,
              message: error.message
            }

            this.postmate.call('error', errorData)
          })
        }
      }
    })

    this.postmate.on('done', (data) => {
      const doneCallback = this.config.callback || (this.config.callbacks && this.config.callbacks.done)
      const requestCallback = this.config.callbacks && this.config.callbacks.requestCallback
      const callbackDefinedByPartner = typeof window['regilyCallback'] === 'function' || typeof window['regilyDoneCallback'] === 'function'
      const saveUrl = this.getPartnerSaveUrl()
      const protectedData = data.protected || {}

      // delete protected data
      data.protected && delete data.protected

      if (partnerConfig.settings.dataTransformSchema) {
        data.mapped = transformData(data, partnerConfig.settings.dataTransformSchema)
      }

      if (saveUrl && data.mapped) {
        requestCallback(saveUrl, data.mapped).then(data => {
          if (!callbackDefinedByPartner) {
            return this.postmate.call('success')
          }
        }).catch(error => {
          const errorName = 'unknown'
          const errorData = {
            name: errorName,
            title: error && error.title,
            message: error && error.message,
            doneCallback: true,
            action: error && error.action,
            path: protectedData.route && protectedData.route.currentPath
          }
          this.postmate.call('error', errorData)
        })
      }

      if (doneCallback) {
        const doneCallbackPromise = doneCallback(data)

        if (doneCallbackPromise && doneCallbackPromise.then) {
          doneCallbackPromise.then((data) => {
            if (data) {
              const customValues = {}

              if (data.welcome) {
                customValues['welcome'] = data.welcome
              }
              this.postmate.call('setCustomValues', customValues)

              if (data.createdUserAccountId) {
                this.postmate.call('checkBb', { accountCode: data.createdUserAccountId })
              }
            }
            this.postmate.call('success')
          }, (error) => {
            const errorName = error.name
            const errorData = {
              name: errorName,
              title: error.title,
              message: error.message,
              doneCallback: true,
              action: error.action,
              path: protectedData.route && protectedData.route.currentPath
            }
            this.postmate.call('error', errorData)
          })
        } else {
          this.postmate.call('success')
        }
      }
    })

    this.postmate.on('initExternalFrame', data => {
      modal.openModal(data, this.moduleOverlay)

      this.positionModuleOverlay()
    })

    this.postmate.on('event', (data) => {
      this.emitEvent(data)
    })

    this.postmate.on('ready', (data) => {
      const readyCallback = this.config.callbacks && this.config.callbacks.ready

      if (readyCallback) {
        readyCallback(data)
      }
    })

    this.postmate.on('authentication', (data) => {
      return this.authenticationCallback(data)
    })

    this.postmate.on('redirectToLogin', (countryCode) => {
      window.location = partnerConfig.settings.loginRedirectURL && partnerConfig.settings.loginRedirectURL(countryCode)
    })

    this.postmate.on('customRedirect', (url) => {
      window.location.assign(url)
    })

    this.postmate.on('openSofortIdent', (data) => {
      const sofortDepositData = JSON.stringify(data.deposit)
      sessionStorage.setItem('redirectDeposit', sofortDepositData)

      window.location = data.identURL
    })

    const loadCallback = this.config.callbacks && this.config.callbacks.load

    if (loadCallback) {
      loadCallback()
    }
  },

  authenticationCallback (data) {
    const authenticationCallback = this.config.callbacks && this.config.callbacks.authentication
    if (authenticationCallback) {
      const promise = authenticationCallback(data)
      const authData = data.authentication

      if (promise && promise.then) {
        promise.then((data) => {
          const authStatus = data.auth
          const knownData = {}
          let altFlowAction

          if (authStatus === 'OK_SHOW_INFO') {
            altFlowAction = 'showInfo'
          } else if (authStatus === 'REQUIRE_LIMITS') {
            altFlowAction = 'requireLimits'
          } else if (authStatus === 'NOT_FOUND') {
            altFlowAction = 'userNotFound'
          } else if (authStatus === 'OK') {
            return this.closeModule()
          }

          storage.setItem('regilyPlayerInfo', authData.personalNumber)

          if (altFlowAction) {
            knownData.app = { altFlowAction }
            knownData.authentication = authData
            this.crossModuleDataTransfer.regilyKnownData = knownData
          }

          this.postmate.call('authenticationDone', { altFlowAction })
        }, (error) => {
          console.error(error)
        })
      }
    }
  },

  handleOngoingAuthentication () {
    const authOrderRef = this.queryParams.orderRef

    if (authOrderRef) {
      this.crossModuleDataTransfer.regilyKnownData = {
        authentication: {
          transactionId: authOrderRef
        }
      }
      return true
    }
    return false
  },

  preparePage () {
    moduleStyling.use()
    const triggers = this.config.triggers || {}
    const selectors = triggers.click || []

    this.delegate = delegateEvent(document.documentElement, selectors, 'click', this.triggerHandler)
  },

  triggerHandler (e) {
    this.setHash(e)
  },

  shouldInstantRun () {
    const triggers = this.config.triggers || {}
    const urlTrigger = triggers.url && window.location.href.match(new RegExp(triggers.url))
    const triggerOnLoad = this.dynamicSettings().regilyTrigger && this.dynamicSettings().regilyTrigger === 'load'
    const isOngoingAuthentication = this.handleOngoingAuthentication()

    return triggerOnLoad || urlTrigger || isOngoingAuthentication || this.isFromRemote
  },

  triggerOpenIfNeeded () {
    if (this.shouldInstantRun() && !this.shouldOpenIframe()) {
      return this.setHash()
    }

    this.openFrameIfNeeded()
  },

  setHash (e) {
    if (e && e.preventDefault) {
      e.preventDefault()
    }

    this.originalHash = window.location.hash.replace(/^#$/, '')
    window.location.hash = this.hashes[0]
    document.activeElement.blur()
  },
  removeHash () {
    window.location.hash = this.originalHash || ''
  },

  shouldOpenIframe () {
    if (this.hashes.indexOf(window.location.hash) > -1) {
      return true
    }
  },

  async openFrameIfNeeded () {
    if (!this.postmate) this.prepareFrame()

    if (this.shouldOpenIframe()) {
      if (this.isFromRemote) {
        remoteStatus.openFrame(
          this.holder,
          this.getDeviceInfo(),
          this.getHost(),
          this.dynamicSettings().regilyLanguage
        )
      }

      this.openModuleWrapper()
      if (!this.postmateHandshake || this.loadingPostmate) {
        console.log('Postmate already starting')
        return false
      }

      this.loadingPostmate = true

      this.postmateHandshake.then(() => {
        this.openFrame()
      }).catch((err) => {
        this.loadingPostmate = false
        console.warn('Could not start postmate in shoudOpenFrame:', err)
        return false
      })
      this.loadingPostmate = false
      return true
    }
  },

  closeFrameIfNeeded () {
    if (!(this.hashes.indexOf(window.location.hash) > -1) && this.originalStyle) {
      this.postmateHandshake.then(this.closeFrame)
      return true
    }
  },

  openModuleWrapper () {
    this.holder.classList.add('in-view')
    this.holder.classList.add('visible')
    setTimeout(() => {
      this.holder.classList.add('show-loader')
    }, 1000)
  },

  openFrame (postmate) {
    const iframeUrl = this.getIframeUrl()
    this.postmate = postmate || this.postmate

    // URL is changed, reload with new release/path
    if (this.postmate && this.iframeUrl !== iframeUrl) {
      this.iframeUrl = iframeUrl
      // If this happens on page-load we get a race, wait until first load is done
      setTimeout(() => {
        if (this.postmate) {
          this.postmate.destroy()
          this.postmate = null
        }
        this.postmateHandshake = null
        return this.openFrameIfNeeded()
      }, 1000)
      return
    }

    if (document.documentElement.dataset.regilyOriginalStyle === undefined) {
      this.originalStyle = {
        documentElement: document.documentElement.getAttribute('style') || '',
        body: document.body.getAttribute('style') || ''
      }
      document.documentElement.dataset.regilyOriginalStyle = JSON.stringify(this.originalStyle)
    }

    this.scrollY = window.scrollY

    document.documentElement.style.overflow = 'hidden'
    document.documentElement.style.width = '100%'
    document.documentElement.style.height = '100%'
    document.documentElement.style.position = 'fixed'
    document.body.style.overflow = 'hidden'
    document.body.style.width = '100%'
    document.body.style.height = '100%'
    document.body.style.position = 'fixed'

    this.holder.classList.add('show-module')

    document.body.scrollTop = this.scrollY

    if (this.frame) {
      this.frame.focus()
      this.frame.contentWindow.focus()
    }

    if (this.isFromRemote) {
      this.postmate.call('openRegistrationShadow', {
        url: this.config.remote.registrationUrl
      })

      this.postmate.on('registrationShadowConnected', () => {
        remoteStatus.showConnectedNotification()
        window.regilyRemote && window.regilyRemote.loader && window.regilyRemote.loader.close()
      })
    }

    if (this.dynamicSettings().regilyReset === 'true') {
      this.postmate.call('reset')
    }

    this.postmate.call('setSofortRedirectURL', this.dynamicSettings().regilySofortUrl || this.sofortDefaultRedirectUrl)

    if (this.dynamicSettings().regilyFf !== undefined) {
      this.postmate.call('setIovation', this.dynamicSettings().regilyFf === 'true')
    }

    if (this.dynamicSettings().regilyBonuses !== undefined) {
      this.postmate.call('setBonuses', this.dynamicSettings().regilyBonuses === 'true')
    }

    const hasKnownData = this.dynamicSettings().regilyKnownData !== undefined || this.dynamicSettings().regilyVariant !== undefined || !!this.crossModuleDataTransfer.regilyKnownData
    if (hasKnownData) {
      try {
        const knownData = this.dynamicSettings().regilyKnownData && JSON.parse(this.dynamicSettings().regilyKnownData)
        const variantData = {
          partner: {
            variant: this.dynamicSettings().regilyVariant || 'core'
          }
        }

        const data = {
          ...knownData,
          ...variantData,
          ...this.crossModuleDataTransfer.regilyKnownData
        }

        for (var i in data) {
          this.postmate.call('setKnownData', {
            storeKey: i,
            data: data[i]
          })
        }
      } catch (error) {
        console.warn('Failed to read `knownData`', error)
      }
    }

    if (this.dynamicSettings().regilyDisableDataLookup === 'true') {
      this.postmate.call('setDataLookup', {
        allowDataLookup: false
      })
    }

    if (this.dynamicSettings().regilyOtp === 'true') {
      this.postmate.call('setOtp', {
        enabled: true
      })
    }

    if (this.dynamicSettings().regilyCustomData !== undefined) {
      const rawData = this.dynamicSettings().regilyCustomData && this.dynamicSettings().regilyCustomData.trim()
      if (rawData !== '') {
        try {
          const parsedData = JSON.parse(rawData)
          if (typeof parsedData === 'object' && Array.isArray(parsedData) === false) {
            for (let prop in parsedData) {
              if (prop === 'verify') {
                this.postmate.call('setVerifyData', {
                  verify: parsedData[prop]
                })
              } else {
                this.postmate.call('setCustomData', {
                  [prop]: parsedData[prop]
                })

                // selected default onus, ensure chapter description text contains the bonus data coming from custom data
                // as selector is not present in casumo-de the first bonusConfig will be selected as the default
                if (prop === 'bonusConfig') {
                  const entries = Object.entries(parsedData[prop])
                  if (entries.length && entries[0]) {
                    const fallbackId = 'casino'
                    const configKey = entries[0][0]
                    const config = entries[0][1]

                    this.postmate.call('selectBonus', {
                      ...config,
                      id: config.id || configKey || fallbackId
                    })
                  }
                }
              }
            }
          }
        } catch (e) {
          console.warn('Invalid Custom data')
        }
      }
    }

    if (this.dynamicSettings().regilyLanguage) {
      console.log(`Module started with language set to "${this.dynamicSettings().regilyLanguage}"`)
    }

    this.postmate.call('setLanguage', {
      language: this.dynamicSettings().regilyLanguage || false,
      partnerServerUrl: getPartnerServeUrl(this.release.data)
    })

    this.postmate.call('devmode', this.dynamicSettings().regilyDevMode === 'true')

    let u = new URL(window.location)
    let sofortData = u && u.searchParams.get('sofort_data')
    if (sofortData) {
      const data = {}
      data.sofort = JSON.parse(sofortData)

      const redirectDepositRaw = sessionStorage.getItem('redirectDeposit')
      const redirectDepositData = redirectDepositRaw && JSON.parse(redirectDepositRaw)
      if (redirectDepositData) {
        data.redirectDeposit = redirectDepositData
        this.postmate.call('setSofortIdent', data)
        sessionStorage.removeItem('redirectDeposit')
      }
    }

    this.postmate.call('open', {
      parentHeight: this.documentHeight,
      parentUrl: `${window.location.origin}${window.location.pathname}${window.location.search}`,
      release: this.release.data && this.release.data.id,
      remote: {
        enabled: !!this.isFromRemote,
        redirectUrl: this.config.remote && this.config.remote.redirectUrl,
        sessionId: this.config.remote && this.config.remote.sessionId
      },
      isFromAffiliate: this.isFromRemote,
      isAuthentication: (this.dynamicSettings().regilyMode === 'signin' && this.dynamicSettings().regilyEc === 'true') || this.dynamicSettings().regilyCountry === 'SE',
      isBonusVisible: this.dynamicSettings().regilyBonuses === 'true',
      parentURL: `${window.location.origin}${window.location.pathname}${window.location.search}`,
      parentOrigin: window.location.origin,
      waitForRemoteConnection: this.dynamicSettings().waitForRemoteConnection === 'true',
    })

    let meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')

    let viewport = document.querySelector('meta[name=viewport]')
    if (viewport) {
      partnerViewport = viewport
      viewport.parentNode.removeChild(viewport)
    }

    document.getElementsByTagName('head')[0].appendChild(meta)

    // Reset data transfer after application
    this.crossModuleDataTransfer = {}
  },
  closeModule () {
    this.removeHash()

    if (this.isFromRemote) {
      remoteStatus.closeFrame()
    }

    let viewport = document.querySelector('meta[name=viewport]')
    if (viewport) viewport.parentNode.removeChild(viewport)

    if (partnerViewport) {
      document.getElementsByTagName('head')[0].appendChild(partnerViewport)
      partnerViewport = null
    }
  },

  closeFrame (postmate) {
    this.postmate = postmate || this.postmate
    this.postmate.call('close', true)
    this.holder.classList.remove('visible')
    window.setTimeout(this.closeFrameCallback, 300)
  },

  closeFrameCallback () {
    this.originalStyle = JSON.parse(document.documentElement.dataset.regilyOriginalStyle)
    document.documentElement.removeAttribute('data-regily-original-style')
    document.documentElement.setAttribute('style', this.originalStyle.documentElement)
    document.body.setAttribute('style', this.originalStyle.body)
    document.body.scrollTop = this.scrollY
    this.holder.classList.remove('show-module')
    this.holder.classList.remove('in-view')
    this.holder.classList.remove('show-loader')
    this.originalStyle = null
    this.scrollY = 0
    if (this.isFromRemote) {
      remoteStatus.closeFrame()
    }
  },

  getHost () {
    const gitBranch = process.env.GIT_BRANCH.split('/')
    const env = getEnv()
    const partnerKey = (partnerConfig && partnerConfig.publicKey) || ''
    const script = document.currentScript || document.querySelector(`script[src*=".regily.com/${partnerKey}.js"]`) || document.querySelector('script[src*="/playground.js"]') || document.querySelector(`script[src*="localhost:8080/${partnerKey}.js"]`)

    if (script && window.URL) {
      const a = document.createElement('a')
      a.href = script.src

      const protocol = a.protocol.length > 4 ? a.protocol : window.location.protocol
      const host = a.host.length ? ((a.port === '80' || a.port === '443') ? a.hostname : a.host) : window.location.host

      return a.origin || `${protocol}//${host}`
    } else if (!window.location.port && ['stable', 'staging'].indexOf(env) !== -1) {
      return `https://${env === 'staging' ? 'staging-' : ''}${partnerConfig.hostnameId}.regily.com`
    } else if (!window.location.port && 'variants'.indexOf(gitBranch[0]) !== -1) {
      return `https://labspreview.regily.com`
    }

    return ''
  },

  getIframeUrl () {
    let subdir = ''
    const host = this.getHost()

    const urlPath = window.location.pathname.substring(1).split('/') // Branch is being sourced from the main version of module, no info about release. We will use directory playground is being served on as info about release dir.

    const isReleasePlayground = this.isPlayground && urlPath[0] !== 'playground.html'
    const isReleaseVariantPreview = (this.isPartnerRegilyPage || window.location.port) && urlPath.length === 3
    const isReleaseSubdir = (isReleasePlayground || isReleaseVariantPreview) && urlPath[0]

    // Special handling for labspreview
    const gitBranch = process.env.GIT_BRANCH.split('/')
    if (gitBranch[0] === 'variants' && (host === 'https://labspreview.regily.com' || host === 'https://labs.regily.com' || host === 'https://staging-labs.regily.com' || host === '')) {
      subdir = `labspreview/${process.env.GIT_BRANCH}/`
      console.log('Variants-build, Used for labspreview, trigger with long path: ', subdir)
    } else if (isReleaseSubdir) {
      subdir = `${isReleaseSubdir}/`
    } else if (this.release.data) {
      subdir = `${this.release.data.subdir}/`
    }

    // Special handling for labspreview
    const moduleVariant = this.dynamicSettings().regilyVariant || 'core'
    let url = moduleVariant ? `${host}/${subdir}${moduleVariant}/index.html` : `${host}/${subdir}index.html`

    const urlParams = getQueryParams(window.location)
    const redirectDepositRaw = sessionStorage.getItem('redirectDeposit')
    if (urlParams && urlParams.sofort_data && redirectDepositRaw) {
      url = updateQueryString(url, 'sofort', true)
    }

    const isStandaloneVariant = ['bank-login-standalone'].includes(this.dynamicSettings().regilyVariant)
    if (isStandaloneVariant) {
      try {
        const knownData = this.dynamicSettings().regilyKnownData
        validateStandaloneData(knownData)
      } catch (e) {
        url = updateQueryString(url, 'standaloneError', true)
      }
    }

    const isVerify = this.dynamicSettings().regilyVariant === 'verify' && !urlParams.skip_validation
    if (isVerify) {
      try {
        const knownData = this.dynamicSettings().regilyKnownData
        validateLoginData(knownData)
      } catch (e) {
        url = updateQueryString(url, 'verificationDataError', true)
      }
    }

    return url
  },

  getPartnerSaveUrl () {
    const scriptKey = partnerConfig.publicKey
    const script = document.currentScript || document.querySelector(`script[src*="${scriptKey}.js"]`)
    const url = script && script.getAttribute('src')
    if (!url) return null

    const getParam = (name, url) => {
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
      const results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return null
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    return getParam('saveUrl', url)
  },

  release: {
    data: null,

    getReleaseInfo () {
      const env = getEnv()
      const urlParams = getQueryParams(window.location)
      const forceRelease = urlParams.forceRegilyRelease

      // Dont check release on others than staging and stable
      const shouldMuteRelease = ['staging', 'stable'].indexOf(env) === -1 || partner.isPlayground
      if (shouldMuteRelease && !forceRelease) return Promise.resolve()

      return new Promise((resolve, reject) => {
        let releasesUrl
        if (forceRelease || (!window.location.port && ['stable', 'staging'].indexOf(env) !== -1)) {
          releasesUrl = `https://${env === 'staging' ? 'staging-' : ''}backoffice.regily.com/releases`
        } else {
          releasesUrl = '/backoffice/releases'
        }

        superagent
          .get(releasesUrl)
          .timeout({
            response: 5000,
            deadline: 10000
          })
          .query({
            new: true,
            partner: partnerConfig.settings.partnerId,
            env: env
          })
          .then((res) => {
            if (forceRelease) {
              console.warn('Forcing test of regily release to:', forceRelease)
              this.data = { 'id': 9999, 'name': forceRelease, 'subdir': forceRelease }
            } else if (res.body.id) {
              this.data = res.body
            }
            resolve(this.data)
          })
          .catch((err) => {
            if (err) {
              console.error('Couldn\'t get or verify test of release, will use default')
            }
            resolve()
          })
      })
    }
  },

  getDeviceInfo () {
    const isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
    const isAndroid = window.navigator.userAgent.indexOf('Android') > 0
    const isDesktop = screen.availWidth >= 1024 && !(isAndroid || isIOS)

    if (isIOS) {
      return 'ios'
    } else if (isAndroid) {
      return 'android'
    } else if (isDesktop) {
      return 'desktop'
    }
  },

  emitEvent (payload) {
    const eventCallback = this.config.callbacks && this.config.callbacks.event
    if (eventCallback) {
      eventCallback(payload)
    }
  }
}

if (isFromRemote()) {
  const scriptKey = partnerConfig.publicKey
  const script = document.currentScript || document.querySelector(`script[src*="${scriptKey}.js"]`)

  script.addEventListener('destroy', () => partner.destroy())
}

for (let key in partner) {
  let value = partner[key]
  if (typeof value === 'function' && value.bind) {
    partner[key] = value.bind(partner)
  }
}

export default partner



// WEBPACK FOOTER //
// ./src/partners/engine.js